import React from 'react';
import Utilities from '../utilities/MasterHeader'
import Ver from '../components/verBlog1'
import Footer from '../components/Footer'
const Descripcion1 = () => {
  return (
    <div>
      <Utilities />
      <Ver />
      <Footer />
    </div>
  );
};

export default Descripcion1;